module.exports = __webpack_public_path__ + "static/media/1POLICY24.10ac8d98.jpg";